module.exports = __webpack_public_path__ + "static/assets/a8162033b0ccec7c13d61aa2f2aa0175.png";